// components/CustomerSay.jsx
import React, { useEffect } from "react";
import User1 from "../assets/img/customer/ananya.png";
import User2 from "../assets/img/customer/rajiv.png";
import User3 from "../assets/img/customer/natasha.png";
import User4 from "../assets/img/customer/emma.png";
import User5 from "../assets/img/customer/lukash.png";
import User6 from "../assets/img/customer/aisha.png";



const CustomerSay = () => {
  const testimonials = [
    {
      img: User1,
      text: "What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.",
      name: "Ananya Mehta",
      role: "Senior Merchandising Manager",
    },
    {
      img: User2,
      text: "Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.",
      name: "Rajiv Nair",
      role: "Employee Welfare & Operations",
    },
    {
      img: User3,
      text: "The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.",
      name: "Natasha Singh",
      role: "Director – Guest Experience",
    },
    {
      img: User4,
      text: "We’ve worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.",
      name: "Emma Collins",
      role: "Senior Buyer – Womenswear",
    },
    {
      img: User5,
      text: "Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.",
      name: "Lukas Weber",
      role: "Procurement Manager",
    },
    {
      img: User6,
      text: "Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.",
      name: "Aisha Al Mansoori",
      role: "Head of Operations",
    },
  ];

  useEffect(() => {
    if (window.Swiper) {
      new window.Swiper(".customerslide", {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3,
          },
        },
      });
    }
  }, []);

  return (
    <section className="customer_say_section">
      <div className="container">
        <div className="brands_content customer_say_title">
          <h2>What Our Customers Say</h2>
        </div>

        <div className="our_customer_say">
          <div className="swiper mySwiper our_work customerslide">
            <div className="swiper-wrapper">
              {testimonials.map((item, index) => (
                <div className="swiper-slide" key={index}>
                  <div className="customer_say">
                    <img src={item.img} alt={item.name} className="logom" />
                    <p>{item.text}</p>
                    <h3>{item.name}</h3>
                    <h4>{item.role}</h4>
                  </div>
                </div>
              ))}
            </div>
            {/* Pagination dots */}
            <div className="swiper-paginationnn"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerSay;
